import {Button, Flex, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {loadAiSettings, saveAiSettings, saveProjectAiProviders} from "../../feature/project/aiSlice";
import {AIProviders} from "../../ai/providers/AIProviders";
import {AIProviderSettings} from "../../ai/providers/AIProvider";
import Title from "antd/es/typography/Title";
import {saveUser} from "../../feature/project/userSlice";

export const AISettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const aiProviderSettings = useAppSelector(state => state.aiSlice.aiProviderSettings)
    const projectAiProviders = useAppSelector(state => state.aiSlice.projectAiProviderSettings)
    const [aiSettings, setAiSettings] = useState<AIProviderSettings[]>(aiProviderSettings)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(loadAiSettings())
        setLoading(false)
    }, []);

    useEffect(() => {
        setAiSettings(aiProviderSettings)
    }, [aiProviderSettings])

    useEffect(() => {
        props.saveFunction(() => {
            dispatch(saveAiSettings({settings: aiSettings}))
        })

    }, [aiSettings]);

    return (
        <Flex vertical={true} gap={10}>
            <Title level={5} style={{margin: 0, paddingTop: 10}}>AI Settings</Title>
            <AIProviders
                settings={aiSettings}
                onChange={(settings) => {
                    setAiSettings(settings)
                }}
            />
        </Flex>
    )

}